import FastImage from 'react-native-fast-image';
import {RFValue} from 'react-native-responsive-fontsize';
import styled, {css} from 'styled-components/native';
import FontAwesome from 'react-native-vector-icons/FontAwesome';

interface Check {
  check?: boolean;
}

export const Container = styled.View`
    margin-top: ${RFValue(6)}px;
`;

export const PaymentTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;
  margin-left: ${RFValue(12)}px;
`;

export const PaymentInfo = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${RFValue(16)}px;
`;

export const Payment = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const BrandContainer = styled.View`
  width: ${RFValue(35)}px;
  height: ${RFValue(35)}px;
  align-items: center;
  border: 2px solid ${({theme}) => theme.colors.border3};
  border-radius: ${RFValue(10)}px;
  justify-content: center;
`;


//@ts-ignore
export const BrandImage = styled(FastImage)`
  width: ${RFValue(20)}px;
  height: ${RFValue(13)}px;
`;

export const PaymentMethodInfo = styled.View`
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const CheckIcon = styled(FontAwesome)<Check>`
  font-size: ${RFValue(16)}px;
  color: ${({theme}) => theme.colors.placeholder};

  ${({check, theme}) =>
    check &&
    css`
      color: ${theme.colors.blue};
    `}
`;

export const BrandAddIcon = styled(FontAwesome)`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.blue};
`;

export const PaymentBrandsContainer = styled.View`
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
`;


//@ts-ignore
export const PaymentBrandsImage = styled(FastImage)`
  width: ${RFValue(12)}px;

  height: ${RFValue(16)}px;
  margin-top: ${RFValue(2)}PX;
`;


export const BannerContainer = styled.View`
  margin:0 -24px;
margin-top: ${RFValue(6)}px;
`;

export const BannerButton = styled.TouchableOpacity`
  align-self: stretch;
  margin: 0 12px;
`;

//@ts-ignore
export const Banner = styled(FastImage)`

  height: ${RFValue(49)}px;
  border-radius: ${RFValue(12)}px;

  border:1px solid ${({theme}) => theme.colors.border_opacity};
`;
